export const common = {
  nav: {
    home: 'Главная',
    about: 'О нас',
    services: 'Услуги',
    doctors: 'Врачи',
    contact: 'Контакты',
    appointment: 'Записаться на приём'
  },
  hero: {
    title: 'Здоровая улыбка начинается здесь',
    subtitle: 'Современная стоматологическая клиника с опытными специалистами и передовым оборудованием для вашего комфорта и здоровья',
    cta: 'Записаться на приём',
    ctaSecondary: 'Наши услуги'
  },
  stats: {
    experience: '20+',
    experienceLabel: 'Лет опыта',
    patients: '5000+',
    patientsLabel: 'Довольных пациентов',
    specialists: '4',
    specialistsLabel: 'Квалифицированных специалиста'
  },
  about: {
    title: 'О нашей клинике',
    description: 'Zimbet32 — современная стоматологическая клиника, предоставляющая полный спектр стоматологических услуг. Мы используем передовые технологии и материалы для обеспечения наилучших результатов для наших пациентов.',
    foundedYear: 'Год основания',
    yearsExperience: 'Лет опыта',
    feature1Title: 'Опытные специалисты',
    feature1Desc: 'Врачи с международными сертификатами и многолетним опытом работы',
    feature2Title: 'Современное оборудование',
    feature2Desc: 'Новейшие технологии и материалы для качественного лечения',
    feature3Title: 'Индивидуальный подход',
    feature3Desc: 'Персональный план лечения для каждого пациента',
    feature4Title: 'Безболезненное лечение',
    feature4Desc: 'Комфортная атмосфера и современная анестезия',
    ctaButton: 'Записаться на приём'
  },
  services: {
    title: 'Наши услуги',
    subtitle: 'Полный спектр стоматологических услуг для всей семьи',
    therapeutic: 'Терапевтическая стоматология',
    therapeuticDesc: 'Лечение кариеса, пульпита, периодонтита с использованием современных материалов и технологий',
    orthopedic: 'Ортопедическая стоматология',
    orthopedicDesc: 'Протезирование зубов, установка коронок, виниров и мостовидных конструкций',
    surgery: 'Хирургическая стоматология',
    surgeryDesc: 'Удаление зубов любой сложности, подготовка к имплантации',
    implantation: 'Имплантация зубов',
    implantationDesc: 'Установка зубных имплантов с использованием передовых технологий',
    orthodontics: 'Ортодонтия',
    orthodonticsDesc: 'Исправление прикуса, установка брекет-систем и элайнеров',
    prevention: 'Профилактика и гигиена',
    preventionDesc: 'Профессиональная чистка зубов, фторирование, герметизация фиссур',
    bookButton: 'Записаться на приём'
  },
  servicePages: {
    breadcrumb: {
      home: 'Главная',
      services: 'Услуги'
    },
    gallery: 'Галерея работ',
    whyUs: 'Почему выбирают нас',
    procedures: 'Процедуры',
    bookAppointment: 'Записаться на приём',
    therapeutic: {
      title: 'Терапевтическая стоматология',
      description: 'Терапевтическая стоматология — это основа здоровья ваших зубов. Наши специалисты используют современные методики и материалы для лечения кариеса, пульпита, периодонтита и других заболеваний. Мы применяем микроскопическое оборудование для точной диагностики и качественного лечения корневых каналов.',
      procedure1: 'Лечение кариеса',
      procedure1Desc: 'Удаление пораженных тканей и восстановление зуба композитными материалами',
      procedure2: 'Лечение пульпита',
      procedure2Desc: 'Эндодонтическое лечение с использованием микроскопа',
      procedure3: 'Лечение периодонтита',
      procedure3Desc: 'Комплексное лечение воспаления тканей вокруг корня зуба',
      procedure4: 'Реставрация зубов',
      procedure4Desc: 'Восстановление формы и функции зуба современными материалами',
      procedure5: 'Лечение под микроскопом',
      procedure5Desc: 'Высокоточное лечение с многократным увеличением',
      procedure6: 'Перелечивание каналов',
      procedure6Desc: 'Повторное эндодонтическое лечение при необходимости',
      benefit1: 'Безболезненное лечение',
      benefit1Desc: 'Современная анестезия и комфортная атмосфера',
      benefit2: 'Качественные материалы',
      benefit2Desc: 'Используем только проверенные композиты премиум-класса',
      benefit3: 'Гарантия результата',
      benefit3Desc: 'Предоставляем гарантию на все виды лечения'
    },
    orthopedic: {
      title: 'Ортопедическая стоматология',
      description: 'Ортопедическая стоматология занимается восстановлением утраченных зубов и их функций. Мы предлагаем все виды протезирования: от одиночных коронок до полных съемных протезов. Используем современные материалы — керамику, диоксид циркония, металлокерамику — для создания эстетичных и долговечных конструкций.',
      procedure1: 'Керамические коронки',
      procedure1Desc: 'Эстетичные коронки из прессованной керамики',
      procedure2: 'Коронки из диоксида циркония',
      procedure2Desc: 'Прочные и биосовместимые конструкции',
      procedure3: 'Керамические виниры',
      procedure3Desc: 'Тонкие накладки для идеальной улыбки',
      procedure4: 'Мостовидные протезы',
      procedure4Desc: 'Восстановление нескольких отсутствующих зубов',
      procedure5: 'Съемное протезирование',
      procedure5Desc: 'Частичные и полные съемные протезы',
      procedure6: 'Протезирование на имплантах',
      procedure6Desc: 'Несъемные конструкции на имплантатах',
      benefit1: 'Индивидуальный подход',
      benefit1Desc: 'Каждая конструкция изготавливается по индивидуальным слепкам',
      benefit2: 'Собственная зуботехническая лаборатория',
      benefit2Desc: 'Контроль качества на всех этапах изготовления',
      benefit3: 'Естественная эстетика',
      benefit3Desc: 'Протезы неотличимы от натуральных зубов'
    },
    surgery: {
      title: 'Хирургическая стоматология',
      description: 'Хирургическая стоматология включает широкий спектр операций — от простого удаления зубов до сложных костнопластических вмешательств. Наши хирурги имеют большой опыт проведения операций любой сложности. Мы используем современное оборудование и методики для минимизации травматичности и ускорения заживления.',
      procedure1: 'Удаление зубов',
      procedure1Desc: 'Атравматичное удаление зубов любой сложности',
      procedure2: 'Удаление зубов мудрости',
      procedure2Desc: 'Безопасное удаление ретинированных и дистопированных зубов',
      procedure3: 'Резекция верхушки корня',
      procedure3Desc: 'Сохранение зуба при воспалении в области корня',
      procedure4: 'Костная пластика',
      procedure4Desc: 'Наращивание костной ткани для имплантации',
      procedure5: 'Синус-лифтинг',
      procedure5Desc: 'Увеличение объема кости на верхней челюсти',
      procedure6: 'Пластика десны',
      procedure6Desc: 'Коррекция уровня и контура десны',
      benefit1: 'Опытные хирурги',
      benefit1Desc: 'Специалисты с многолетним опытом сложных операций',
      benefit2: 'Современное оборудование',
      benefit2Desc: 'Пьезохирургия и другие инновационные технологии',
      benefit3: 'Быстрое заживление',
      benefit3Desc: 'Минимальная травматичность и короткий период реабилитации'
    },
    implantation: {
      title: 'Имплантация зубов',
      description: 'Имплантация зубов — это современный и надежный способ восстановления утраченных зубов. Мы используем качественные имплантаты ведущих производителей и передовые технологии для достижения долговечного результата. Наши специалисты имеют большой опыт в проведении имплантации любой сложности.',
      procedures: {
        single: {
          title: 'Одиночная имплантация',
          description: 'Установка одного имплантата для замены отсутствующего зуба'
        },
        multiple: {
          title: 'Множественная имплантация',
          description: 'Восстановление нескольких зубов с помощью имплантатов'
        },
        allOn4: {
          title: 'All-on-4',
          description: 'Полное протезирование челюсти на 4 имплантатах'
        },
        bonePlasty: {
          title: 'Костная пластика',
          description: 'Наращивание костной ткани для установки имплантатов'
        },
        sinusLift: {
          title: 'Синус-лифтинг',
          description: 'Увеличение объема кости в области верхней челюсти'
        },
        immediate: {
          title: 'Немедленная имплантация',
          description: 'Установка имплантата сразу после удаления зуба'
        }
      },
      benefits: {
        permanent: {
          title: 'Долговечность',
          description: 'Имплантаты служат десятилетиями при правильном уходе'
        },
        natural: {
          title: 'Естественный вид',
          description: 'Имплантаты выглядят и функционируют как натуральные зубы'
        },
        boneSaving: {
          title: 'Сохранение кости',
          description: 'Предотвращение атрофии костной ткани челюсти'
        }
      },
      gallery: {
        surgery: 'Процедура имплантации',
        crown: 'Установка коронки на имплантат',
        allOn4: 'Протезирование All-on-4',
        xray: 'Рентген имплантата',
        boneGraft: 'Костная пластика',
        result: 'Результат имплантации'
      }
    },
    orthodontics: {
      title: 'Ортодонтия',
      description: 'Ортодонтическое лечение помогает исправить прикус и выровнять зубы, создавая красивую и здоровую улыбку. Мы предлагаем различные системы коррекции — от классических брекетов до современных элайнеров. Наши ортодонты разработают индивидуальный план лечения для достижения наилучшего результата.',
      procedures: {
        braces: {
          title: 'Металлические брекеты',
          description: 'Классическая и эффективная система коррекции прикуса'
        },
        invisalign: {
          title: 'Invisalign',
          description: 'Прозрачные съемные элайнеры для незаметного лечения'
        },
        lingual: {
          title: 'Лингвальные брекеты',
          description: 'Брекеты, устанавливаемые с внутренней стороны зубов'
        },
        children: {
          title: 'Детская ортодонтия',
          description: 'Коррекция прикуса у детей и подростков'
        },
        retainers: {
          title: 'Ретейнеры',
          description: 'Закрепление результата после снятия брекетов'
        },
        consultation: {
          title: 'Ортодонтическая консультация',
          description: 'Диагностика и составление плана лечения'
        }
      },
      benefits: {
        beautiful: {
          title: 'Красивая улыбка',
          description: 'Ровные зубы и правильный прикус улучшают внешний вид'
        },
        health: {
          title: 'Здоровье зубов',
          description: 'Правильный прикус снижает риск заболеваний'
        },
        confidence: {
          title: 'Уверенность',
          description: 'Красивая улыбка повышает самооценку'
        }
      },
      gallery: {
        braces: 'Металлические брекеты',
        invisalign: 'Элайнеры Invisalign',
        beforeAfter: 'До и после лечения',
        examination: 'Ортодонтический осмотр',
        ceramic: 'Керамические брекеты',
        result: 'Результат лечения'
      }
    },
    prevention: {
      title: 'Профилактика и гигиена',
      description: 'Профилактика — это основа здоровья зубов и десен. Регулярная профессиональная гигиена полости рта помогает предотвратить развитие кариеса, заболеваний десен и других проблем. Мы рекомендуем проходить профилактические осмотры и чистку зубов каждые 6 месяцев.',
      procedures: {
        cleaning: {
          title: 'Профессиональная чистка',
          description: 'Удаление зубного налета и камня ультразвуком'
        },
        whitening: {
          title: 'Отбеливание зубов',
          description: 'Профессиональное отбеливание для белоснежной улыбки'
        },
        fluoride: {
          title: 'Фторирование',
          description: 'Укрепление эмали фторсодержащими препаратами'
        },
        checkup: {
          title: 'Профилактический осмотр',
          description: 'Регулярная диагностика состояния зубов и десен'
        },
        sealants: {
          title: 'Герметизация фиссур',
          description: 'Защита жевательных поверхностей от кариеса'
        },
        education: {
          title: 'Обучение гигиене',
          description: 'Консультация по правильному уходу за зубами'
        }
      },
      benefits: {
        savings: {
          title: 'Экономия',
          description: 'Профилактика дешевле лечения запущенных заболеваний'
        },
        health: {
          title: 'Здоровье',
          description: 'Предотвращение развития серьезных проблем'
        },
        early: {
          title: 'Раннее выявление',
          description: 'Обнаружение проблем на ранней стадии'
        }
      },
      gallery: {
        cleaning: 'Профессиональная чистка',
        whitening: 'Отбеливание зубов',
        fluoride: 'Фторирование',
        checkup: 'Профилактический осмотр',
        sealant: 'Герметизация фиссур',
        result: 'Здоровые зубы'
      }
    }
  },
  doctors: {
    title: 'Наши специалисты',
    subtitle: 'Команда профессионалов с многолетним опытом работы',
    experience: 'Опыт работы',
    years: 'лет'
  },
  contact: {
    title: 'Свяжитесь с нами',
    subtitle: 'Запишитесь на приём или задайте вопрос',
    form: {
      name: 'Ваше имя',
      phone: 'Телефон',
      email: 'Email',
      message: 'Сообщение',
      submit: 'Отправить заявку',
      success: 'Спасибо! Мы свяжемся с вами в ближайшее время.',
      error: 'Произошла ошибка. Пожалуйста, попробуйте позже.'
    },
    info: {
      address: 'Адрес',
      addressValue: 'MD-2012, мун. Кишинёв, ул. Букурешть, 60',
      phone: 'Телефон',
      phoneValue: '+373 22 123 456',
      email: 'Email',
      emailValue: 'info@zimbet32.md',
      hours: 'Часы работы',
      hoursValue: 'Пн-Пт: 9:00 - 19:00'
    }
  },
  footer: {
    description: 'Современная стоматологическая клиника с опытными специалистами',
    quickLinks: 'Быстрые ссылки',
    contactInfo: 'Контактная информация',
    copyright: 'Zimbet32. Все права защищены.'
  }
};